<div [formGroup]='parent'>

  <div class="question-style normal-ques-style mb-10 alignPos">
    <span>
      {{question.questionText}}
    </span>
    <div class="info-icon"
      *ngIf="question.helpText">
      <app-tool-tip-notification [childId]="'inputComp'" [tooltipData]="initializeToolTipDateComp(question)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
      </app-tool-tip-notification>
    </div>
  </div>

  <div class="col-md-12 clear-all questionGaps">
    <div class="ml-0">
      <div class="col-md-2">
        <div class="mb-10-new">
          <label class="durationFont">days</label>
        </div>
        <div *ngIf="daysRangeData">
          <input [ngClass]="{'invalid-error-border': (parent.get('days').touched && parent.get('days').errors)}"
            class="Rectangle-157-Copy-3 btn-border" [formControlName]="'days'"
            id="{{(indexToAppend || indexToAppend === 0) ? (question.id + '-' + indexToAppend + '-days') : (question.id + '-days') }}"
            [(ngModel)]="selectedDays" aria-label="days" (keyup)="setValueToFrom($event, 'days')" OnlyNumber="true" placeholder="000"
            [maxlength]="3" [value]="" [minValue]="daysRangeData.valueMin" [maxValue]="daysRangeData.valueMax"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"  inputmode="numeric"/>
        </div>
      </div>
      <div class="col-md-2">
        <div class="mb-10-new">
          <label class="durationFont">months</label>
        </div>
        <div *ngIf="monthsRangeData">
          <input [ngClass]="{'invalid-error-border': (parent.get('months').touched && parent.get('months').errors)}"
            class="Rectangle-157-Copy-3 btn-border" aria-label="months" [formControlName]="'months'"
            id="{{(indexToAppend || indexToAppend === 0) ? (question.id + '-' + indexToAppend + '-months') : (question.id + '-months') }}"
            [(ngModel)]="selectedMonths" (keyup)="setValueToFrom($event, 'months')" [maxlength]="3" [value]=""
            OnlyNumber="true" placeholder="000" [minValue]="monthsRangeData.valueMin"
            [maxValue]="monthsRangeData.valueMax" onkeypress="return event.charCode >= 48 && event.charCode <= 57" inputmode="numeric"/>
        </div>
      </div>
      <div class="col-md-2">
        <div class="mb-10-new">
          <label OnlyNumber="true" class="durationFont">years</label>
        </div>
        <div *ngIf="yearsRangeData">
          <input [ngClass]="{'invalid-error-border': (parent.get('years').touched && parent.get('years').errors)}"
            class="Rectangle-157-Copy-3 btn-border" aria-label="years" [formControlName]="'years'"
            id="{{(indexToAppend || indexToAppend === 0) ? (question.id + '-' + indexToAppend + '-years') : (question.id + '-years') }}"
            [(ngModel)]="selectedYears" (keyup)="setValueToFrom($event, 'years')" [maxlength]="3" [value]=""
            OnlyNumber="true" placeholder="000" [minValue]="yearsRangeData.valueMin"
            [maxValue]="yearsRangeData.valueMax" onkeypress="return event.charCode >= 48 && event.charCode <= 57" inputmode="numeric"/>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-validation-error"
  *ngIf="(parent.get('days').touched && parent.get('days').errors || 
parent.get('months').touched && parent.get('months').errors || parent.get('years').touched && parent.get('years').errors)">
  <i class="icon icon-error" aria-hidden="true"></i>
  <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">Please enter a value
  </p>
</div>